export default ":host .aside {\n  height: 100%;\n}\n:host .aside .aside-menu {\n  margin: 0;\n}\n:host .menu-text {\n  white-space: nowrap;\n}";